import { IPhamViBanActionTypes } from "../../action-types/category/IPhamViBanActions";
import { eReducerStatusBase } from "../../reducer-model/eReducerStatusBase";
import {IPhamViBanReducer} from "../../reducer-model/category/IPhamViBanReducer";
const initState: IPhamViBanReducer = {
    status: eReducerStatusBase.is_not_initialization,
    phamViban: [],
    };

export const phamViBanReducer = (
    state: IPhamViBanReducer = initState,
    action: IPhamViBanActionTypes
): IPhamViBanReducer => {
    switch (action.type) {
        case "PHAM_VI_BAN_LOAD_START":
        return {
            ...state,
            status: eReducerStatusBase.is_loading,
        };
        case "PHAM_VI_BAN_LOAD_SUCCESS":
        return {
            ...state,
            status: eReducerStatusBase.is_completed,
            phamViban: action.payload,
        };
        case "PHAM_VI_BAN_LOAD_ERRR":
        return {
            ...state,
            status: eReducerStatusBase.is_completed,
        };
        case "PHAM_VI_BAN_SHOW_MODAL":
        return {
            ...state,
            isShowEditModal: true,
            phamViBanEditing: action.payload,
        };
        case "PHAM_VI_BAN_CLOSE_MODAL":
        return {
            ...state,
            isShowEditModal: false,
        };
        case "PHAM_VI_BAN_SAVE_START":
        return {
            ...state,
            status: eReducerStatusBase.is_saving,
        };
        case "PHAM_VI_BAN_SAVE_SUCCESS":
        return {
            ...state,
            status: eReducerStatusBase.is_need_reload,
            isShowEditModal: false,
        };
        case "PHAM_VI_BAN_SAVE_ERRR":
        return {
            ...state,
            status: eReducerStatusBase.is_completed,
        };
        default:
        return state;
    }
    }